var EffySite;
(function (EffySite) {
    EffySite["CALCULEO"] = "calculeo";
    EffySite["EFFY"] = "effy";
    EffySite["LAPRIMEENERGIE"] = "laprimeenergie";
    EffySite["QUELLEENERGIE"] = "quelleenergie";
    EffySite["PRO"] = "pro";
    EffySite["PRO_SERENITE"] = "pro-serenite";
})(EffySite || (EffySite = {}));

/**
 * Generated bundle index. Do not edit.
 */

export { EffySite };
